import { Image } from "react-bootstrap";
import { usePvSection3 } from "./landing-pv-section3.hook";
import { OtherSolutionsImage } from "src/assets";

export const PvSection3 = () => {
  const { t } = usePvSection3();
  return (
    <div className="d-flex flex-column flex-lg-row">
      <div className="pe-lg-5 p-0 col-12 col-lg-6">
        <div className="font-12-roman fw-bold">{t("landing_pv.section3.pretitle")}</div>
        <hr
          className="mt-3 mb-4"
          style={{ width: "40px", border: "1px solid" }}
        />
        <div className="my-4 pv-section3-title">
          {t("landing_pv.section3.title")}
        </div>

        <div className="font-18-roman pv-section3-description">
          {t("landing_pv.section3.description")}
        </div>
      </div>
      <div className="mt-5 mt-lg-0 col-12 col-lg-6">
        <Image src={OtherSolutionsImage} width={"100%"} height={"100%"} />
      </div>
    </div>
  );
};
